import { ArrowRight, Users, UsersThree } from "@phosphor-icons/react";
import Modal from "./Modal";
import type {
  MemberInviteLimitPrompt,
  MemberInviteUpgradePrompt,
} from "./memberInviteUpgradePrompt";

export const MemberInviteUpgradeModal = ({
  isOpen,
  onClose,
  onPrimaryAction,
  prompt,
}: {
  isOpen: boolean;
  onClose: () => void;
  onPrimaryAction: () => void;
  prompt: MemberInviteUpgradePrompt;
}) => (
  <Modal
    isOpen={isOpen}
    onClose={onClose}
    title={prompt.title}
    width="max-w-[500px]"
    containerClassName="overflow-hidden rounded-2xl border border-white/70 shadow-[0_24px_60px_rgba(26,22,47,0.18)]"
    headerClassName="px-6 py-5"
    bodyClassName="px-6 pb-6 pt-4"
    showHeaderDivider
  >
    <div>
      <div className="mx-auto mb-5 flex h-16 w-16 items-center justify-center rounded-[18px] border border-[#E8EBF3] bg-[#F4F5F8] text-[#1A162F] shadow-[0_8px_20px_rgba(26,22,47,0.08)]">
        <Users size={28} weight="regular" />
      </div>

      <div className="mx-auto max-w-[370px] text-center">
        <p className="mx-auto text-sm font-normal leading-6 text-[#666F8D]">
          {prompt.description}
        </p>
      </div>

      <div className="mt-6 flex items-center justify-center gap-3">
        <button
          type="button"
          onClick={onClose}
          className="inline-flex items-center justify-center rounded-[10px] border border-[#E8EBF3] bg-white px-4 py-2.5 text-sm font-medium text-[#1A162F] transition-colors hover:bg-[#F8F9FC]"
        >
          {prompt.secondaryActionLabel}
        </button>
        <button
          type="button"
          onClick={onPrimaryAction}
          className="inline-flex items-center gap-2 rounded-[10px] bg-[#1A162F] px-4 py-2.5 text-sm font-medium text-white shadow-[0_10px_20px_rgba(26,22,47,0.12)] transition-colors hover:bg-[#231D3E]"
        >
          {prompt.primaryActionLabel}
          <ArrowRight size={16} weight="regular" />
        </button>
      </div>
    </div>
  </Modal>
);

export const MemberInviteLimitModal = ({
  isOpen,
  onClose,
  onPrimaryAction,
  prompt,
}: {
  isOpen: boolean;
  onClose: () => void;
  onPrimaryAction: () => void;
  prompt: MemberInviteLimitPrompt;
}) => (
  <Modal
    isOpen={isOpen}
    onClose={onClose}
    title={prompt.title}
    width="max-w-[520px]"
    containerClassName="overflow-hidden rounded-2xl border border-white/70 shadow-[0_24px_60px_rgba(26,22,47,0.18)]"
    headerClassName="px-6 py-5"
    bodyClassName="px-6 pb-6 pt-4"
    showHeaderDivider
  >
    <div>
      <div className="mx-auto mb-5 flex h-16 w-16 items-center justify-center rounded-[18px] bg-[#1A162F] text-white shadow-[0_8px_20px_rgba(26,22,47,0.12)]">
        <UsersThree size={26} weight="duotone" />
      </div>

      <div className="mx-auto max-w-[360px] text-center">
        <p className="mx-auto text-sm font-normal leading-6 text-[#666F8D]">
          {prompt.description}
        </p>
      </div>

      <div className="mt-6 flex items-center justify-center gap-3">
        <button
          type="button"
          onClick={onClose}
          className="inline-flex items-center justify-center rounded-[10px] border border-[#E8EBF3] bg-white px-4 py-2.5 text-sm font-medium text-[#1A162F] transition-colors hover:bg-[#F8F9FC]"
        >
          {prompt.secondaryActionLabel}
        </button>
        <button
          type="button"
          onClick={onPrimaryAction}
          className="inline-flex items-center gap-2 rounded-[10px] bg-[#1A162F] px-4 py-2.5 text-sm font-medium text-white shadow-[0_10px_20px_rgba(26,22,47,0.12)] transition-colors hover:bg-[#231D3E]"
        >
          {prompt.primaryActionLabel}
          <ArrowRight size={16} weight="regular" />
        </button>
      </div>
    </div>
  </Modal>
);
